import { noop } from "lodash-es";
import { useEffect, useRef } from "react";

export function useInterval(callback: () => void, delay: number | undefined): void {
    const savedCallback = useRef<() => void>(noop);

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        const tick = (): void => savedCallback.current();

        if (delay != null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}
